import React from 'react';
import { useTableColumnsListEvent } from '../../../../hooks/ListEvent/useTableColumnsListEvent';
import { Spin, Table } from 'antd';
import { useTranslation } from 'react-i18next';
import './TableListEvent.scss';
import { useSelector } from 'react-redux';

export const TableListEvent = ({ onEdit }) => {
  const { t } = useTranslation();
  const { listEvent, isLoading } = useSelector((state) => state.eduEventRegistry);
  const columns = useTableColumnsListEvent(listEvent, onEdit);

  return (
    <Spin tip={t('intersections.loadingPleaseWait') + '...'} spinning={isLoading}>
      <Table columns={columns} dataSource={listEvent} size="small" bordered />
    </Spin>
  );
};
